export var removeAllWhitespaces = function removeAllWhitespaces(value, originalValue) {
    return value.replace(/\s/g, "");
};
